/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom"

import { ColumnIcon, EmptyCircle, FilledCircle, RowIcon } from "assests/GmsIcons";
import { ADD_FILTER, BEST, CONFIRM_PRIMARY_MESSAGE, CONFIRM_SECONDARY_MESSAGE, INCOMPATIBLE, PRIMARY_MESSAGES, REMOVE_FILTER, CHANGE_RULE_WARNING } from "./RuleConstants";
import UpdatePDW from "Components/GMS/Products/PDW/UpdatePDW";
import AuthManager from "Common/AuthManager";
import { toast } from "Components/DesignSystem/Toast/useToast";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import Select from "react-select";
import debounce from "lodash/debounce";
import { ATTRIBUTE, ATTRIBUTE_VALUES, BULK_ACTION, COLUMN, COMPARED_WITH, DISPLAY, DOWNLOAD_WARNING_MESSAGE, PRODUCTS, RATING_LEVELS, ROW, SELECT_ATTRIBUTE, SELECT_A_VALUE, SELECT_CATEGORY, UPLOAD_WARNING_MESSAGE } from "./RuleConstants";
import ValidatePDW from "Components/GMS/Products/PDW/ValidatePDW";
import ButtonDropDown from "./CBM_rule_BUilder";
import { RulesContext } from "../RulesContext";
import GMSBorderlessButton from "Components/Common/components/GMSBorderlessButton";
import ConfirmModal from "Pages/GMS/ARS/Components/ConfirmModal";
import { PROCEED } from "Pages/GMS/ARS/ARSConstants";
import { AppContext } from "Context/AppContext";
import Bootbox from "../../../../Common/BootBoxManager";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

const CBMCategorySelector = ({
  ruleBody,
  ruleId,
  load_Rule_Details,
  type,
  commit,
}) => {
  const appContext = useContext(AppContext);
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const [showValidatePopup, setShowValidatePopup] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const {
    selectedCategories,
    setSelectedCategories,
    categoriesList,
    CBMOptions,
    setCBMOptions,
    ruleDispatch,
    setPaginationParams,
    cbmRuleId,
    setCellStates,
    setCompatibilityData,
    cellStates
  } = useContext(RulesContext);
  const {
    leftCatListOption,
    rightCatListOption,
    leftCatAttributeSet,
    rightCatAttributeSet,
    rightValuesAttr,
    leftValuesAttr,
    rightAttributeValueName,
    rightAttributeValueId,
    leftAttributeValueId,
    leftAttributeValueName,
    compatibilityLevel,
    isProductFilter,
  } = CBMOptions;

  const [leftSearchValue, setLeftSearchValue] = useState("");
  const [leftPage, setLeftPage] = useState(1);
  const [leftOptions, setLeftOptions] = useState([]);
  const [leftIsLoading, setLeftIsLoading] = useState(false);
  const [leftNoResults, setLeftNoResults] = useState(false);

  const [rightSearchValue, setRightSearchValue] = useState("");
  const [rightPage, setRightPage] = useState(1);
  const [rightOptions, setRightOptions] = useState([]);
  const [isRightLoading, setIsRightLoading] = useState(false);
  const [noRightResults, setNoRightResults] = useState(false);

  const handleUploadModal = () => {
    if (ruleId === "0" && cbmRuleId) {
      toast.warning(UPLOAD_WARNING_MESSAGE);
      return;
    }
    setShowUpdatePopup((prev) => {
      return !prev;
    });
  };

  useEffect(() => {
    if (ruleBody) {
      setSelectedCategories((prevState) => {
        return {
          ...prevState,
          leftCategory: { id: ruleBody.leftCatID, name: "" },
          rightCategory: { id: ruleBody.rightCatID, name: "" },
        };
      });
    }
  }, [ruleBody]);

  // NEW: Force compatibility level to always be level2 (2 Levels)
  useEffect(() => {
    if (compatibilityLevel !== "level2") {
      setCBMOptions((prevState) => ({
        ...prevState,
        compatibilityLevel: "level2",
      }));
    }
  }, [compatibilityLevel, setCBMOptions]);

  const handleValidate = () => {
    if (ruleId === "0" && cbmRuleId === "") {
      toast.warning(UPLOAD_WARNING_MESSAGE);
      return;
    }
    setShowValidatePopup((prev) => {
      return !prev;
    });
  };

  useEffect(() => {
    const fetchAttributeValues = (attr, page, searchValue, isLeft) => {
      if (
        attr !== "" &&
        attr !== SELECT_ATTRIBUTE &&
        isProductFilter !== undefined &&
        isProductFilter
      ) {
        return isLeft
          ? getLeftAttributeValues(attr, page, searchValue)
          : getRightAttributeValues(attr, page, searchValue);
      }
    };
    fetchAttributeValues(leftValuesAttr, leftPage, leftSearchValue, true);
    fetchAttributeValues(rightValuesAttr, rightPage, rightSearchValue, false);
  }, [
    leftValuesAttr,
    leftPage,
    leftSearchValue,
    rightValuesAttr,
    rightPage,
    rightSearchValue,
    isProductFilter,
  ]);

  const handl_Options_Change = (e) => {
    e.persist();

    setCellStates({});
    setCompatibilityData([]);
    if (leftCatListOption === "products" && !isProductFilter) {
      setCBMOptions((prevState) => ({
        ...prevState,
        leftValuesAttr: "",
        rightValuesAttr: "",
        leftAttributeValueName: "",
        rightAttributeValueName: "",
        leftAttributeValueId: "",
        rightAttributeValueId: "",
      }));
    }
    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    if (e.target.id === "leftCatListOption") {
      setCBMOptions((prev) => {
        return {
          ...prev,
          [e.target.id]: e.target.value,
          rightCatListOption: e.target.value,
        };
      });
    } else {
      setCBMOptions((prev) => {
        return {
          ...prev,
          [e.target.id]: e.target.value,
          leftCatListOption: e.target.value,
        };
      });
    }
    ruleDispatch({ type: "CBM_RULE_TYPE", data: [] });
  };

  const resetState = (options) => {

    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    setCBMOptions((prev) => ({
      ...prev,
      ...options,
    }));
  };

  const resetStateUponRightCategoryChange = () => {

    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    resetState({
      rightAttributeValueId: "",
      rightAttributeValueName: "",
      rightValuesAttr: "",
      rightCatAttributeSet: [],
      rightAttributeValues: [],
      rightCatProductList: [],
    });
  };

  const resetStateUponLeftCategoryChange = () => {

    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    resetState({
      leftAttributeValueId: "",
      leftAttributeValueName: "",
      leftValuesAttr: "",
      leftCatAttributeSet: [],
      leftAttributeValues: [],
      leftCatProductList: [],
    });
  };

  const resetStateUponRightAttributeChange = () => {

    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    resetState({
      rightAttributeValueId: "",
      rightAttributeValueName: "",
      leftAttributeValues: [],
      rightAttributeValues: [],
      rightCatProductList: [],
    });
  };

  const resetStateUponLeftAttributeChange = () => {

    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    resetState({
      leftAttributeValueId: "",
      leftAttributeValueName: "",
      leftAttributeValues: [],
      rightAttributeValues: [],
      leftCatProductList: [],
    });
  };

  const hasCBMValidRules = () => {
    return Object.values(cellStates).some(value => value !== 0);
  };

  const handleCategoryChange = (id, ItemID, ItemName) => {
    if (hasCBMValidRules()) {
      Bootbox.confirm(
        "Change Category?",
        CHANGE_RULE_WARNING,
        false,
        [handle_change, id, ItemID, ItemName]
      );
    } else {
      handle_change(id, ItemID, ItemName);
    }
  };

  const handle_change = (
    id,
    ItemID,
    ItemName,
    isAttribute,
    attributeFieldName
  ) => {
    if (id === "rightCategory" || id === "leftCategory") {
      setCellStates({});
    }
    const resetStateFunction = {
      rightCategory: resetStateUponRightCategoryChange,
      leftCategory: resetStateUponLeftCategoryChange,
      rightValuesAttr: resetStateUponRightAttributeChange,
      leftValuesAttr: resetStateUponLeftAttributeChange,
    }[id];

    if (resetStateFunction) {
      resetStateFunction();
    }

    if (ItemID !== "Select Product Type") {
      if (!isAttribute) {
        setSelectedCategories((prevState) => ({
          ...prevState,
          [id]: { id: ItemID, name: ItemName },
        }));
      } else {
        setCBMOptions((prevState) => ({
          ...prevState,
          [id]: ItemID,
          [attributeFieldName]: ItemName,
        }));
      }
    }
  };

  const downloadCBM = async () => {
    if (ruleId === "0" && cbmRuleId) {
      toast.warning(DOWNLOAD_WARNING_MESSAGE);
      return;
    }
    try {
      let endPoint =
        leftCatListOption === "products"
          ? `rule/products/export/${cbmRuleId}`
          : `rule/attribute_values/export/${ruleId}`;
      const productPayload = {
        categories: [
          {
            id: selectedCategories.rightCategory.id,
            filters:
              isProductFilter &&
                rightValuesAttr !== "" &&
                rightValuesAttr !== SELECT_ATTRIBUTE
                ? {
                  AttrValueId: rightAttributeValueId,
                  attrID: rightValuesAttr,
                }
                : {},
          },
          {
            id: selectedCategories.leftCategory.id,
            filters:
              isProductFilter &&
                leftValuesAttr !== "" &&
                leftValuesAttr !== SELECT_ATTRIBUTE
                ? { AttrValueId: leftAttributeValueId, attrID: leftValuesAttr }
                : {},
          },
        ],
      };
      const payload =
        leftCatListOption === "values"
          ? { attribute_ids: [rightValuesAttr, leftValuesAttr] }
          : productPayload;
      var productDownloadEndPoint = `${api_base_url}${endPoint}`;
      appContext?.downloadCBMFile(productDownloadEndPoint, payload);
    } catch (error) {
      console.error("downloadCBM ~ error:", error);
    }
  };

  const getLeftAttributeValues = async (
    attributeId,
    page,
    searchString = ""
  ) => {
    try {
      if (attributeId === "") return;
      const res = await ServiceWrapper.doPost(
        `${api_base_url}get_attribute_values?page=${page}&limit=10&search=${searchString}`,
        { attribute_ids: [attributeId] },
        null,
        AuthManager.getGmsToken()
      );
      const attributeValues = res?.data?.data[0]?.attribute_values ?? [];
      handleLeftAttributeResponse(attributeValues);
    } catch (error) {
      console.log("getAttributeValues ~ error:", error);
      setLeftOptions([]);
    } finally {
      setLeftIsLoading(false);
    }
  };

  const handleLeftAttributeResponse = (response) => {
    const options = (response || []).map((item) => ({
      value: item.id,
      label: item.value,
    }));

    if (leftPage === 1 && leftAttributeValueId) {
      const isAttributeIdPresent = options.some(
        (option) => option.value === leftAttributeValueId
      );
      const updatedOptions = isAttributeIdPresent
        ? options
        : [
          {
            value: leftAttributeValueId,
            label: leftAttributeValueName ?? "",
          },
          ...options,
        ];

      setLeftOptions((prevData) =>
        leftPage === 1 ? updatedOptions : [...prevData, ...updatedOptions]
      );
    } else {
      const filteredAttribute = options.filter(
        (option) => option.value !== leftAttributeValueId
      );
      setLeftOptions((prevData) =>
        leftPage === 1 ? filteredAttribute : [...prevData, ...filteredAttribute]
      );
    }

    setLeftNoResults(options.length === 0);
  };

  const loadMoreOptionsLeft = async () => {
    if (!leftNoResults) {
      setLeftPage((prevPage) => prevPage + 1);
    } else {
      setLeftIsLoading(false);
    }
  };

  const debouncedLoadMoreOptionsLeft = useCallback(
    debounce(() => loadMoreOptionsLeft(), 500),
    [leftPage]
  );

  const debouncedLeftSearch = debounce((value) => {
    setLeftSearchValue(value);
    setLeftPage(1);
  }, 500);

  const onLeftInputChange = (input) => {
    if (input === "") {
      setLeftSearchValue(input);
      setLeftPage(1);
      return;
    }
    debouncedLeftSearch(input);
  };

  const handleLeftMenuScrollToBottom = () => {
    setLeftIsLoading(true);
    debouncedLoadMoreOptionsLeft();
  };

  const handleLeftAttributeValueChange = (ev) => {

    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    resetState({
      leftAttributeValueId: "",
      leftAttributeValueName: "",
      leftAttributeValues: [],
      leftCatProductList: [],
    });
    setCBMOptions((prev) => {
      return {
        ...prev,
        leftAttributeValueId: ev.value,
        leftAttributeValueName: ev.label,
      };
    });
  };

  // right
  const getRightAttributeValues = async (
    attributeId,
    page,
    searchString = ""
  ) => {
    try {
      const res = await ServiceWrapper.doPost(
        `${api_base_url}get_attribute_values?page=${page}&limit=10&search=${searchString}`,
        { attribute_ids: [attributeId] },
        null,
        AuthManager.getGmsToken()
      );
      const attributeValues = res?.data?.data[0]?.attribute_values ?? [];
      handleAttributeResponse(attributeValues);
    } catch (error) {
      console.log("getAttributeValues ~ error:", error);
      setRightOptions([]);
    } finally {
      setIsRightLoading(false);
    }
  };

  const handleAttributeResponse = (response) => {
    const options = (response || []).map((item) => ({
      value: item.id,
      label: item.value,
    }));

    if (rightPage === 1 && rightAttributeValueId) {
      const isAttributeIdPresent = options.some(
        (option) => option.value === rightAttributeValueId
      );
      const updatedOptions = isAttributeIdPresent
        ? options
        : [
          {
            value: rightAttributeValueId,
            label: rightAttributeValueName ?? "",
          },
          ...options,
        ];

      setRightOptions((prevData) =>
        rightPage === 1 ? updatedOptions : [...prevData, ...updatedOptions]
      );
    } else {
      const filteredAttribute = options.filter(
        (option) => option.value !== rightAttributeValueId
      );
      setRightOptions((prevData) =>
        rightPage === 1
          ? filteredAttribute
          : [...prevData, ...filteredAttribute]
      );
    }

    setNoRightResults(options.length === 0);
  };

  const loadMoreOptions = async () => {
    if (!noRightResults) {
      setRightPage((prevPage) => prevPage + 1);
    } else {
      setIsRightLoading(false);
    }
  };

  const debouncedLoadMoreOptions = useCallback(
    debounce(() => loadMoreOptions(), 500),
    [rightPage]
  );

  const debouncedRightSearch = debounce((value) => {
    setRightSearchValue(value);
    setRightPage(1);
  }, 500);

  const onRightInputChange = (input) => {
    if (input === "") {
      setRightSearchValue(input);
      setRightPage(1);
      return;
    }
    debouncedRightSearch(input);
  };

  const handleMenuScrollToBottom = () => {
    setIsRightLoading(true);
    debouncedLoadMoreOptions();
  };

  const handleAttributeValueChange = (ev) => {

    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    resetState({
      rightAttributeValueId: "",
      rightAttributeValueName: "",
      rightAttributeValues: [],
      rightCatProductList: [],
    });
    setCBMOptions((prev) => {
      return {
        ...prev,
        rightAttributeValueId: ev.value,
        rightAttributeValueName: ev.label,
      };
    });
  };

  const handleProductFilterChange = () => {
    if (commit) return;

    setPaginationParams({ pageNumber: 1, pageSize: 10 });
    resetState({
      leftCatProductList: [],
      rightCatProductList: [],
    });
    setCBMOptions((prevState) => {
      return {
        ...prevState,
        isProductFilter: !isProductFilter,
      };
    });
  };

  const handleOnConfirm = () => {
    downloadCBM();
    closeConfirmModal();
  };

  const closeConfirmModal = () => {
    setShowModal(false);
  };

  const openConfirmModal = () => {
    setShowModal(true);
  };

  const bulkActionOptions = [
    { name: "Upload", onClick: handleUploadModal },
    { name: "Validate", onClick: handleValidate },
    { name: "Download XLS", onClick: openConfirmModal },
  ];

  /* CBM dark pass (okf/rules § 4.6): react-select paints its own chrome, so it
     needs the token-driven styles the Add Filters VALUE picker got in § 4.3 —
     styling only, every handler and option payload untouched. No menuPortal here:
     these sit in normal page flow, not inside a Dialog scroller. */
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      textAlign: "left",
      backgroundColor: state.isFocused ? "var(--ds-surface-sunken, #f4f5f7)" : "transparent",
      color: "var(--ds-ink, #172b4d)",
    }),
    control: (provided) => ({
      ...provided,
      textAlign: "left",
      backgroundColor: "var(--ds-surface, #ffffff)",
      borderColor: "var(--ds-edge-strong, #8891a0)",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "var(--ds-surface-raised, #ffffff)",
    }),
    singleValue: (provided) => ({ ...provided, color: "var(--ds-ink, #172b4d)" }),
    input: (provided) => ({ ...provided, color: "var(--ds-ink, #172b4d)" }),
    placeholder: (provided) => ({ ...provided, color: "var(--ds-ink-secondary, #505866)" }),
  };

  const getPrimaryMessage = () => {
    return PRIMARY_MESSAGES[compatibilityLevel];
  };

  const modalRoot = document.querySelector("#modal-root");

  return (
    <div>
      <div className="cbm-category-card tw-py-3 tw-bg-surface-sunken tw-rounded-md tw-border tw-border-edge tw-my-4">
        <div className="tw-flex tw-justify-end tw-px-3">
          <ButtonDropDown
            name={BULK_ACTION}
            options={bulkActionOptions}
            disabled={ruleId === "0" || type === "copy"}
          />
        </div>
        <div className="flex_base_style tw-justify-around tw-pb-4 ">
          <div className="tw-w-[40%]">
            <div className="flex_base_style tw-gap-1">
              <span className="icon-follow-ink tw-text-ink tw-flex tw-items-center"><ColumnIcon /></span>
              <label className="tw-text-ink tw-text-sm tw-font-semibold">
                {COLUMN}
              </label>
            </div>
            <div className="column_row_container_style">
              <div className="tw-w-[46%] tw-mt-2">
                <label className="tw-text-sm tw-text-ink-tertiary tw-block">
                  {SELECT_CATEGORY}
                </label>
                <select
                  className="form-select tw-text-sm tw-bg-surface tw-text-ink tw-border-edge tw-border-1 shadow-none tw-mt-1"
                  id="rightCategory"
                  data-testid="rule-right-category-select"
                  aria-label="RuleBody Status"
                  value={selectedCategories.rightCategory.id}
                  onChange={(e) =>
                    handleCategoryChange(
                      e.target.id,
                      e.target.value,
                      e.target.selectedOptions[0].text
                    )
                  }
                  disabled={type === 'copy' ? false : commit}
                >
                  <option defaultValue={SELECT_CATEGORY}>
                    {SELECT_CATEGORY}
                  </option>
                  {categoriesList.map((category, index) => {
                    return (
                      <option value={category.id} key={index}>
                        {rightCatListOption === "products"
                          ? `${category.name}`
                          : `${category.name}`}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="tw-w-[46%] tw-mt-2">
                <label className="tw-text-sm tw-text-ink-tertiary tw-block">
                  {DISPLAY}
                </label>
                <select data-testid="components-cbmcategoryselector-select-1"
                  className="form-select tw-text-sm tw-bg-surface tw-text-ink tw-border-edge tw-border-1 shadow-none tw-mt-1"
                  id="rightCatListOption"
                  aria-label="RuleBody Status"
                  value={rightCatListOption}
                  onChange={handl_Options_Change}
                  disabled={type === 'copy' ? false : commit}
                >
                  <option value="">{SELECT_A_VALUE}</option>
                  <option value="products">{PRODUCTS}</option>
                  <option value="values">{ATTRIBUTE_VALUES}</option>
                </select>
              </div>
            </div>
            <div className="column_row_container_style">
              {(
                rightCatListOption === "products"
                  ? isProductFilter
                  : rightCatListOption === ""
                    ? false
                    : true
              ) ? (
                <div className="tw-w-[46%] tw-mt-2">
                  <label className="tw-text-sm tw-text-ink-tertiary tw-block">
                    {ATTRIBUTE}
                  </label>
                  <select data-testid="components-cbmcategoryselector-select-2"
                    className="form-select tw-text-sm tw-bg-surface tw-text-ink tw-border-edge tw-border-1 shadow-none tw-mt-1"
                    id="rightValuesAttr"
                    aria-label="RuleBody Status"
                    value={rightValuesAttr}
                    disabled={type === 'copy' ? false : commit}
                    onChange={(e) =>
                      handle_change(
                        e.target.id,
                        e.target.value,
                        e.target.selectedOptions[0].text,
                        true,
                        "rightValuesAttrName"
                      )
                    }
                  >
                    <option selected>{SELECT_ATTRIBUTE}</option>
                    {rightCatAttributeSet &&
                      rightCatAttributeSet.map((attribute, index) => {
                        return (
                          <option
                            value={attribute.id}
                            data-name={attribute.name}
                            key={index}
                          >
                            {attribute.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              ) : null}
              {isProductFilter &&
                rightCatListOption === "products" &&
                rightValuesAttr &&
                rightValuesAttr !== SELECT_ATTRIBUTE ? (
                <div className="tw-w-[46%] tw-mt-2">
                  <label className="tw-text-sm tw-text-ink-tertiary tw-block">
                    {ATTRIBUTE_VALUES}
                  </label>
                  <Select
                    id="rightAttributeValueId"
                    className="tw-outline-none"
                    options={rightOptions}
                    styles={customStyles}
                    onMenuScrollToBottom={handleMenuScrollToBottom}
                    isLoading={isRightLoading}
                    isSearchable
                    onInputChange={(input) => onRightInputChange(input)}
                    isDisabled={type === 'copy' ? false : commit}
                    value={
                      rightAttributeValueId
                        ? {
                          value: rightAttributeValueId,
                          label: rightAttributeValueName,
                        }
                        : null
                    }
                    onChange={(ev) => {
                      handleAttributeValueChange(ev);
                    }}
                    placeholder={"Select Attribute Values"}
                    maxMenuHeight={220}
                    menuPlacement="auto"
                    isClearable={false}
                    components={{ IndicatorSeparator: () => null }}
                  />
                </div>
              ) : null}
            </div>
          </div>
          <div
            className={`flex_base_style tw-w-[10%] ${rightCatListOption === "products"
              ? isProductFilter
                ? "tw-mb-4"
                : "tw-mt-12"
              : rightCatListOption === ""
                ? "tw-mt-12"
                : "tw-mb-4"
              }`}
          >
            <label className="tw-text-ink tw-font-medium tw-text-sm">
              {COMPARED_WITH}
            </label>
          </div>
          <div className="tw-w-[40%]">
            <div className="flex_base_style tw-gap-1">
              <span className="icon-follow-ink tw-text-ink tw-flex tw-items-center"><RowIcon /></span>
              <label className="tw-text-ink tw-text-sm tw-font-semibold">
                {ROW}
              </label>
            </div>
            <div className="column_row_container_style">
              <div className="tw-w-[46%] tw-mt-2">
                <label className="tw-text-sm tw-text-ink-tertiary tw-block">
                  {SELECT_CATEGORY}
                </label>
                <select
                  className="form-select tw-text-sm tw-bg-surface tw-text-ink tw-border-edge tw-border-1 shadow-none tw-mt-1"
                  id="leftCategory"
                  data-testid="rule-left-category-select"
                  aria-label="RuleBody Status"
                  value={selectedCategories.leftCategory.id}
                  onChange={(e) =>
                    handleCategoryChange(
                      e.target.id,
                      e.target.value,
                      e.target.selectedOptions[0].text
                    )
                  }
                  disabled={type === 'copy' ? false : commit}
                >
                  <option selected>{SELECT_CATEGORY}</option>
                  {categoriesList.map((category, index) => {
                    return (
                      <option value={category.id} key={index}>
                        {leftCatListOption === "products"
                          ? `${category.name}`
                          : `${category.name}`}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="tw-w-[46%] tw-mt-2">
                <label className="tw-text-sm tw-text-ink-tertiary tw-block">
                  {DISPLAY}
                </label>
                <select data-testid="components-cbmcategoryselector-select-3"
                  className="form-select tw-text-sm tw-bg-surface tw-text-ink tw-border-edge tw-border-1 shadow-none tw-mt-1"
                  id="leftCatListOption"
                  aria-label="RuleBody Status"
                  value={leftCatListOption}
                  onChange={handl_Options_Change}
                  disabled={type === 'copy' ? false : commit}
                >
                  <option value="">{SELECT_A_VALUE}</option>
                  <option value="products">{PRODUCTS}</option>
                  <option value="values">{ATTRIBUTE_VALUES}</option>
                </select>
              </div>
            </div>
            <div className="column_row_container_style">
              {(
                leftCatListOption === "products"
                  ? isProductFilter
                  : leftCatListOption === ""
                    ? false
                    : true
              ) ? (
                <div className="tw-w-[46%] tw-mt-2">
                  <label className="tw-text-sm tw-text-ink-tertiary tw-block">
                    {ATTRIBUTE}
                  </label>
                  <select data-testid="components-cbmcategoryselector-select-4"
                    className="form-select tw-text-sm tw-bg-surface tw-text-ink tw-border-edge tw-border-1 shadow-none tw-mt-1"
                    id="leftValuesAttr"
                    aria-label="RuleBody Status"
                    value={leftValuesAttr}
                    disabled={type === 'copy' ? false : commit}
                    onChange={(e) =>
                      handle_change(
                        e.target.id,
                        e.target.value,
                        e.target.selectedOptions[0].textContent,
                        true,
                        "leftValuesAttrName"
                      )
                    }
                  >
                    <option selected>{SELECT_ATTRIBUTE}</option>
                    {leftCatAttributeSet &&
                      leftCatAttributeSet.map((attribute, index) => {
                        return (
                          <option value={attribute.id} key={index}>
                            {attribute.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              ) : null}
              {isProductFilter &&
                leftCatListOption === "products" &&
                leftValuesAttr !== SELECT_ATTRIBUTE &&
                leftValuesAttr ? (
                <div className="tw-w-[46%] tw-mt-2">
                  <label className="tw-text-sm tw-text-ink-tertiary tw-block">
                    {ATTRIBUTE_VALUES}
                  </label>
                  <Select
                    id="leftAttributeValue"
                    className="tw-outline-none"
                    options={leftOptions}
                    styles={customStyles}
                    onMenuScrollToBottom={handleLeftMenuScrollToBottom}
                    isLoading={leftIsLoading}
                    onInputChange={(input) => onLeftInputChange(input)}
                    isSearchable
                    isDisabled={type === 'copy' ? false : commit}
                    value={
                      leftAttributeValueId
                        ? {
                          value: leftAttributeValueId,
                          label: leftAttributeValueName,
                        }
                        : null
                    }
                    onChange={(ev) => {
                      handleLeftAttributeValueChange(ev);
                    }}
                    placeholder={SELECT_ATTRIBUTE}
                    maxMenuHeight={220}
                    menuPlacement="auto"
                    isClearable={false}
                    components={{ IndicatorSeparator: () => null }}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="tw-flex tw-justify-start tw-px-5">
          {leftCatListOption === "products" && (type === 'copy' ? true : !commit) ? (
            <GMSBorderlessButton
              name={isProductFilter ? REMOVE_FILTER : ADD_FILTER}
              fontSize="14px"
              color="var(--ds-accent, #0747A6)"
              onClick={handleProductFilterChange}
            />
          ) : null}
        </div>
      </div>
      <div className="flex_base_style tw-w-full tw-mt-8 tw-gap-3 tw-border-b tw-border-t tw-py-2 tw-border-edge">
        <div className="flex_base_style tw-gap-2">
          <label className="tw-text-ink tw-min-w-fit tw-text-sm tw-font-semibold">
            {RATING_LEVELS}
          </label>
          {/* OLD: Original CompatibilityFilters component */}
          {/* <CompatibilityFilters
            compatibilityLevel={compatibilityLevel}
            toggleSelectInput={toggleSelectInput}
            defaultCompatibilityValue={defaultCompatibilityValue}
            changeLevelSelectValue={changeLevelSelectValue}
            toggleDefaultSelectInput={toggleDefaultSelectInput}
            toggleDefaultCompatibilityValue={toggleDefaultCompatibilityValue}
            disabled={!commit}
          /> */}
          
          {/* NEW: Static "2 Levels" text */}
          <div className="tw-px-3 tw-py-1 tw-border tw-border-edge tw-rounded tw-bg-surface-sunken tw-text-ink tw-text-sm">
            <span>2 Levels</span>
          </div>
        </div>
        <div className="flex_base_style tw-gap-2">
          <span className="cbm-rating-glyph tw-flex tw-items-center"><EmptyCircle /></span>
          <label className="tw-text-ink-tertiary tw-text-sm">{INCOMPATIBLE}</label>
        </div>
        {/* OLD: Commented out Good and Better rating levels */}
        {/* {compatibilityLevel === "level3" || compatibilityLevel === "level4" ? (
          <div className="flex_base_style tw-gap-2">
            <OutlineCircle />
            <label className="tw-text-ink-tertiary tw-text-sm">{GOOD}</label>
          </div>
        ) : null}
        {compatibilityLevel === "level4" ? (
          <div className="flex_base_style tw-gap-2">
            <HalfFilledCircle />
            <label className="tw-text-ink-tertiary tw-text-sm">{BETTER}</label>
          </div>
        ) : null} */}
        
        {/* NEW: Simplified - Only show Best for all levels */}
        <div className="flex_base_style tw-gap-2">
          <span className="cbm-rating-glyph tw-flex tw-items-center"><FilledCircle /></span>
          <label className="tw-text-ink-tertiary tw-text-sm">{BEST}</label>
        </div>
      </div>
      {showUpdatePopup &&
        modalRoot &&
        ReactDOM.createPortal(
          <UpdatePDW
            showUpdatePopup={showUpdatePopup}
            modalUpdateClose={handleUploadModal}
            compatibilityLevel={CBMOptions?.compatibilityLevel}
            fetchData={() => {
              load_Rule_Details(cbmRuleId ? cbmRuleId : ruleId);
            }}
            type={"CBM"}
            display={leftCatListOption}
            ruleId={cbmRuleId ? cbmRuleId : ruleId}
          />,
          modalRoot
        )}
      {showValidatePopup &&
        modalRoot &&
        ReactDOM.createPortal(
          <ValidatePDW
            showValidatePopup={showValidatePopup}
            modalValidateClose={handleValidate}
            compatibilityLevel={CBMOptions?.compatibilityLevel}
            fetchData={() => { }}
            type={"CBM"}
            ruleId={cbmRuleId ? cbmRuleId : ruleId}
          />,
          modalRoot
        )}

      <ConfirmModal
        showModal={showModal}
        closeModal={closeConfirmModal}
        onConfirm={handleOnConfirm}
        primaryMessage={CONFIRM_PRIMARY_MESSAGE}
        primarySubMessage={getPrimaryMessage()}
        secondaryMessage={CONFIRM_SECONDARY_MESSAGE}
        secondarySubMessage={PROCEED}
      />
    </div>
  );
};
export default CBMCategorySelector;